/*burdanbi@gmail.com
 https://www.burdanbi.xyz/login/google/callback
*/
export const Config = {
    googleOAuthClientId:'489428291501-30o07h0s5d379q59ef7radhgh6kn0ssc.apps.googleusercontent.com',
    apiHost: 'https://site.bulut12.xyz:32103/'
}